export default __webpack_public_path__ + "static/media/settings.1a9de11f.svg";